import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedDate from './FormattedDate';
import { Small } from 'foundations-components/transitional/components/Small';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { ApprovalDueDateModal } from './ApprovalDueDateModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ApprovalDueDate = () => {
  const approval = useApprovalContext();
  const {
    isRequester,
    isSuperAdmin,
    isPending
  } = useApprovalConditions();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const canEditDueDate = isPending && (isRequester || isSuperAdmin);
  if (!approval.data) {
    return null;
  }
  const {
    dueDate
  } = approval.data;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      gap: "100",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSidebar.dueDate.title"
        })
      }), /*#__PURE__*/_jsxs(Small, {
        children: [dueDate ? /*#__PURE__*/_jsx(FormattedDate, {
          date: dueDate
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSidebar.dueDate.notSet"
        }), /*#__PURE__*/_jsx(Tooltip, {
          placement: "top",
          title: !isPending ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalSidebar.dueDate.cannotSetAfterConcluded"
          }) : !(isRequester || isSuperAdmin) ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalSidebar.dueDate.onlyRequesterOrAdmin"
          }) : undefined,
          disabled: canEditDueDate,
          children: /*#__PURE__*/_jsx(Link, {
            paddingInlineStart: "200",
            onClick: () => setIsModalOpen(true),
            disabled: !canEditDueDate,
            children: dueDate ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'productApprovals.ApprovalSidebar.dueDate.edit'
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'productApprovals.ApprovalSidebar.dueDate.setDueDate'
            })
          })
        })]
      })]
    }), isModalOpen && /*#__PURE__*/_jsx(ApprovalDueDateModal, {
      currentDueDate: dueDate,
      onClose: () => setIsModalOpen(false)
    })]
  });
};